import { commonTypes } from './common';

export const types = {};

export const initialState = {
  setContextDataExec: 0,
  userType: '',
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const InitReducer = (state = JSON.parse(JSON.stringify(initialState)), action) => {
  switch (action.type) {
    case commonTypes.RESET_FLOW: {
      return {
        ...state,
        setContextDataExec: 1,
      };
    }
    case 'SET_CONTEXT_DATA': {
      const { userType } = action.payload;

      if (typeof userType !== 'undefined') {
        let { setContextDataExec } = state;
        setContextDataExec += 1;
        return {
          ...state,
          setContextDataExec,
          userType,
        };
      }
      return { ...state };
    }
    default: return { ...state };
  }
};

export const actions = {};

export default InitReducer;
